<script src="../../store/services.module.js"></script>
<template>
    <v-row class="fill-height">
        <v-col>
            <v-card>
                <v-card-title>
                    <v-icon left>mdi-chair-rolling</v-icon>
                    Serviços
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="paginationOptions.search"
                        class="mr-3"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        placeholder="Informe o Nome do Serviço"
                        single-line
                        hide-details
                        @keydown="buscar()"
                        @click:append="buscar()"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-switch
                        v-model="services.active"
                        :label=" `Exibindo ${services.active? 'Ativos': 'Inativos'}`"
                        single-line
                        hide-details
                        class="mr-3"
                        style="width: 200px"
                        @change="buscar()"
                    ></v-switch>
                    
                    <v-btn
                        class="btn-new"
                        :to="{ name: 'servicesCreate' }"
                    >
                        <v-icon left>mdi-plus</v-icon>
                        Adicionar
                    </v-btn>
                </v-card-title>
                <v-alert type="warning" outlined v-show="!services"
                >Nenhum Serviço Encontrado
                </v-alert
                >
                
                <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="filteredServicesItems()"
                    :options.sync="options"
                    :server-items-length="services.totalItems"
                    :search.sync="paginationOptions.search"
                    item-key="id"
                    class="elevation-1"
                    v-show="services"
                    :footer-props="{
                        'items-per-page-options': [10, 25, 50, 75, 100]
                      }"
                >
                    <template v-slot:item.value="{ item }">
                        {{ item.value | money }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    class="btn-lyndus"
                                    v-bind="attrs"
                                    v-on="on"
                                    :to="{ name: 'service', params: { id: item.id } }"
                                >
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>
                            </template>
                            <span>Visualizar</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-card>
        </v-col>
    </v-row>

</template>

<script>
import {mapGetters} from "vuex";
import store from "@/store";
import {mask} from "vue-the-mask";

import {SERVICE_SEARCH} from "@/store/actions/service.type";
import {SERVICE_RESET_STATE, SET_SERVICE_PAGINATION} from "@/store/mutations/service.type";

export default {
    name: "ListarUsuarios",
    directives: {mask},
    props: {
        source: String
    },

    components: {},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        await store.dispatch(SERVICE_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        Promise.all([
            store.dispatch(SERVICE_RESET_STATE),
            store.dispatch(SERVICE_SEARCH)
        ]).then(() => {
            next();
        });
    },
    async beforeDestroy() {
        if(!this.$route.path.includes('/services')){
            localStorage.removeItem('servicesOptions')
            localStorage.removeItem('servicePaginationOptions')
        }
    },
    data: () => ({
        //Lista de Usuários
        pagination: {
            sortBy: "name"
        },
        ativo: true,

        options: {},
        paginationOptions: {},
        selected: [],
        headers: [
            {
                text: "Serviço",
                align: "left",
                value: "name"
            },
            // { text: "Instituição", value: "instituicao" },
            {text: "Categoria", value: "categoryName"},
            {text: "Valor", value: "value"},
            {text: "Visualizar", value: "actions", sortable: false}
        ],

        formIsValid: false,

        textRules: [
            v => !!v || "Este campo é obrigatório"
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],
    }),
    methods: {
        //Methods Lista Usuarios
        toggleAll() {
            if (this.selected.length) this.selected = [];
            else this.selected = this.dados.slice();
        },
        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending;
            } else {
                this.pagination.sortBy = column;
                this.pagination.descending = false;
            }
        },
        buscar() {
            const {sortBy, sortDesc, itemsPerPage, page} = this.options
            this.servicePagination.search = this.paginationOptions.search

            store.commit(SET_SERVICE_PAGINATION, {
                page: page,
                itemsPerPage: itemsPerPage,
                orderBy: sortBy,
                sortDesc: sortDesc[0]
            })
            store.dispatch(SERVICE_SEARCH);
        },

        reset() {
            this.$refs.formUsuario.reset();
        },

        filteredServicesItems() { 
            const items = this.services.items
            const search = this.servicePagination.search ? this.servicePagination.search.toLowerCase() : ""
            if(search){
                this.options.itemsPerPage = this.services.totalItems
                this.options.page = 1
                const exactMatches = [];
                const partialMatches = [];

                items.forEach(item => {
                    const itemValues = Object.values(item).map(value => String(value).toLowerCase());
                    const isExactMatch = itemValues.some(value => value.startsWith(search));
                    const isPartialMatch = itemValues.some(value => value.includes(search));
                    
                    if (isExactMatch) {
                        exactMatches.push(item);
                    } else if (isPartialMatch) {
                        partialMatches.push(item);
                    }
                });

                return [...exactMatches,...partialMatches];
            }
            else {
                if(this.options.itemsPerPage == this.services.totalItems){
                    this.options.itemsPerPage = 10
                }
                return items;
            } 
        }
    },
    mounted() {
        if (localStorage.getItem('servicesOptions')){
            this.options = JSON.parse(localStorage.getItem('servicesOptions'))
        }
        if (localStorage.getItem('servicePaginationOptions')){
            this.paginationOptions = JSON.parse(localStorage.getItem('servicePaginationOptions'))
        }
    },
    watch: {
        options: {
            handler(newOptions) {
                this.buscar()
                const parsed = JSON.stringify(newOptions)
                localStorage.setItem('servicesOptions', parsed)
            },
            deep: true,
        },
        paginationOptions: {
            handler(newSearch) {
                this.buscar()
                const parsed = JSON.stringify(newSearch)
                localStorage.setItem('servicePaginationOptions', parsed)
            },
            deep: true,
        }
    },
    computed: {
        // ...mapState({
        //   courses: state => state.
        // })

        ...mapGetters(["services", "checkUsers", "servicePagination"])
    },
};
</script>
